class CollectionLoadMore {
  constructor() {
    this.init();
  }

  init() {
    if (window.collectionLoadMoreInitialized) return;
    window.collectionLoadMoreInitialized = true;

    // 文書全体でクリックを検知する方式に変更
    document.addEventListener('click', async (e) => {
      const button = e.target.closest('#LoadMoreButton');
      if (!button) return;

      e.preventDefault();
      console.log('LoadMore button clicked!');

      const grid = document.getElementById('product-grid');
      const nextUrl = button.dataset.nextUrl;

      if (!grid || !nextUrl) {
        console.warn('Grid or nextUrl missing', { grid, nextUrl });
        return;
      }

      button.classList.add('loading');
      button.disabled = true;

      try {
        const response = await fetch(nextUrl);
        const text = await response.text();
        const html = new DOMParser().parseFromString(text, 'text/html');

        const newItems = html.querySelectorAll('#product-grid .grid__item');
        const newButton = html.getElementById('LoadMoreButton');

        console.log('Fetched new items count:', newItems.length);

        newItems.forEach(item => grid.appendChild(item));

        if (newButton && newButton.dataset.nextUrl) {
          button.dataset.nextUrl = newButton.dataset.nextUrl;
          button.classList.remove('loading');
          button.disabled = false;
        } else {
          console.log('No more pages. Removing button.');
          button.remove();
        }
      } catch (err) {
        console.error('Load more failed:', err);
        button.classList.remove('loading');
        button.disabled = false;
      }
    });
  }
}

new CollectionLoadMore();